export type EmailChangeStep = "credentials" | "mfa" | "pending";

export type EmailChangeChannel = "email" | "sms" | null;

export interface EmailChangeFormData {
  newEmail: string;
  currentPassword: string;
  code: string;
}

export const emailChangeErrorMessage = (error: unknown): string => {
  const status =
    typeof error === "object" && error !== null && "status" in error
      ? Number((error as { status?: unknown }).status)
      : undefined;
  if (status === 400) return "Check your current password or verification code and try again.";
  if (status === 409) return "Another email change is still in its security window. Try again later.";
  if (status === 429) return "Too many attempts. Wait before trying again.";
  return "The email change request could not be completed. Try again.";
};
